import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useVacationsWaiting from '../../customHooks/useVacationsWaiting';

import ShowManagerVacationsComp from './ShowManagerVacationsComp/ShowManagerVacationsComp';

function ShowManagerVacationsMainPage() {

const authMe = useSelector(state => state.authme.data);

const { fetchVacations , vacationsArr , loadingResult , error } = useVacationsWaiting();

    
//====useEffect start here====

useEffect(()=>{
  fetchVacations(1 , "");
},[])

//====useEffect end here====

  return (
    <div>
        {
         ( loadingResult ) ?
         (<></>)
         :
         (   
        (authMe?.is_manager ) &&
             (
              <>
              {
                (error) &&
                ( <div style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}} >
                    <span style={{color:"red"}} dir='rtl' >{error}</span>
                  </div> ) 
              }
              {
             ( vacationsArr.length  > 0 ) ?
            (
            <ShowManagerVacationsComp fetchVacations={fetchVacations} vacationsArr={vacationsArr.length > 3 ? vacationsArr.slice(0,3) : vacationsArr} 
              showMore = {vacationsArr.length > 3 ? true : false}
            />)
             :
            (<></>)
            }
            </>  
             )
   
        ) 
        }

    </div>
  )
}

export default ShowManagerVacationsMainPage;